// extracted by mini-css-extract-plugin
module.exports = {"textArea":"styles_textArea__3wwOH"};